/** Curriculum — Treppe aus Stufen (Entwurf Marcel, 28.09.2026:
 *  `Component 26.svg`). Menüleiste „Curriculum"; vorher stand dort derselbe
 *  Doktorhut wie bei „Creator" (der Hut gehört seit 28.09.2026 zu „Lernende").
 *
 *  Ans Symbolraster angeglichen:
 *  - Nur die Kontur, 2px Strich mit runden Ecken wie die übrigen
 *    Menü-Symbole — gefüllt wirkte die Treppe neben den Linien-Symbolen zu
 *    wuchtig (Marcel). Die Linie liegt 1 nach innen versetzt, damit die
 *    Außenkante dort bleibt, wo die gefüllte Form endete (5–26).
 *  - Farbe `currentColor` statt fest `#253551`.
 *  - Fläche auf 26 zugeschnitten (`viewBox="2.5 2.5 26 26"`, Koordinaten wie
 *    im Entwurf) statt der 31er: gezeichnet ist die Treppe 21 breit — genau
 *    das Maß der übrigen Symbole (20–22 von 26). In der 31er-Fläche wirkte
 *    sie im Menü ein Viertel kleiner als ihre Nachbarn. */
export const curriculumIcon = `
<svg width="100%" height="100%" viewBox="2.5 2.5 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 25H25V6H20V13H13V20H6Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>
`;
